import { parse } from 'date-fns'
import { POST } from '@/api'

/**
 * 他社取り込みメール
 */
export default {
  namespaced: true,
  state: {
    list: [],
    busy: false,
  },
  mutations: {
    set(state, mails = []) {
      state.list = mails
    },
    busy(state, busy = false) {
      state.busy = busy
    },
    clear(state) {
      state.list = []
    },
  },
  getters: {
    all: ({ list }) => list,
  },
  actions: {
    async get({ commit }, id) {
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/v2/reservation/sync/mail', { reservationId: id })
      if (status === 200) {
        commit(
          'set',
          data.map(mail => ({
            ...mail,
            lastUpdateTime: parse(mail.lastUpdateTime),
          })),
        )
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
